﻿import m from "mithril";
import i18n from "../../../shared/i18n/i18n";
import Component_Unit_Certificate_Editor from "./component_unit_certificate_editor";
import Component_Unit_Certificate_Settings from "./component_unit_certificate_settings";

let loading, unit, tab = "editor";

const Page_Unit_Certificate = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("certificate_unit")),
                        m(".toolbar-menu", [
                            m("div", {
                                class: tab === "editor" ? "active" : "", onclick: function () {
                                    tab = "editor";
                                }
                            }, "Editor"),
                            m("div", {
                                class: tab === "settings" ? "active" : "", onclick: function () {
                                    tab = "settings";
                                }
                            }, "Settings")
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    tab === "editor" ? m(Component_Unit_Certificate_Editor, {unit: unit.properties})
                        : tab === "settings" ? m(Component_Unit_Certificate_Settings, {unit: unit.properties})
                            : ""
                ] : m(".text-gray padding", "Unable to load unit")
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};
export default Page_Unit_Certificate;
